import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_4 = { class: "d-flex flex-column align-center" }
const _hoisted_5 = {
  key: 0,
  class: "mb-1"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Autocomplete',
  async setup(__props) {

let __temp: any, __restore: any


const { field, control, inputModel, handleUpdate } = inject('input') as InputInjection

const search = ref('')
const model = ref(field.value.display)
const items = ref((
  ([__temp,__restore] = _withAsyncContext(() => field.value.items())),
  __temp = await __temp,
  __restore(),
  __temp
))
const loading = ref(false)

const updateItems = useDebounceFn(async () => {
  loading.value = true
  items.value = await field.value.items(search)
  loading.value = false
}, 500)

const setValue = (value: any) => {
  const autocomplete = field.value.options.autocomplete
  if (isFunction(autocomplete)) {
    // Use autocomplete to set
    autocomplete(value)   
  } else {
    // Set value directly
    inputModel.value = value
  }
  // Send update event
  handleUpdate(value)
}

// Show append if sync, flag, or help is present
const ui = useUiStore()
const showAppend = computed(() => {
  return (ui.showSync && control.value.sync) || control.value.flag || control.value.help
})


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_sync_marker = _resolveComponent("hy-inputs-sync-marker")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_unref(field).remote)
    ? (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps({ key: 0 }, _unref(control), {
        modelValue: _unref(model),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
          setValue
        ],
        search: _unref(search),
        "onUpdate:search": [
          _cache[1] || (_cache[1] = ($event: any) => (_isRef(search) ? (search).value = $event : null)),
          _unref(updateItems)
        ],
        items: _unref(items),
        chips: _unref(control).multiple,
        loading: _unref(loading),
        "no-filter": "",
        "hide-no-data": "",
        "return-object": ""
      }), _createSlots({ _: 2 }, [
        (_unref(showAppend))
          ? {
              name: "append",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_ctx.$ui.showSync && _unref(control).sync)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_hy_inputs_sync_marker, {
                          sources: _unref(control).sync
                        }, null, 8, ["sources"])
                      ]))
                    : (_unref(control).flag)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_v_tooltip, { bottom: "" }, {
                            activator: _withCtx(({ props }) => [
                              _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                _createVNode(_component_hy_icon, {
                                  name: "Warning",
                                  small: ""
                                })
                              ], 16)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_unref(control).flag), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : (_unref(control).help)
                        ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
                            key: 2,
                            "help-prompt": _unref(control).help
                          }, null, 8, ["help-prompt"]))
                        : _createCommentVNode("", true)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1040, ["modelValue", "search", "items", "chips", "loading", "onUpdate:search"]))
    : (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps({ key: 1 }, _unref(control), {
        modelValue: _unref(field).value,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_unref(field).value) = $event)),
          _unref(handleUpdate)
        ],
        items: _unref(items),
        chips: _unref(control).multiple
      }), _createSlots({ _: 2 }, [
        (_unref(showAppend))
          ? {
              name: "append",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.$ui.showSync && _unref(control).sync)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_hy_inputs_sync_marker, {
                          sources: _unref(control).sync
                        }, null, 8, ["sources"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(control).help)
                    ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
                        key: 1,
                        "help-prompt": _unref(control).help
                      }, null, 8, ["help-prompt"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1040, ["modelValue", "items", "chips", "onUpdate:modelValue"]))
}
}

})